$( document ).ready(function() {

  $('.item-level-1.item-has-sub>a').click(function (event) {
    event.preventDefault();
    $('.item-level-1').removeClass('active');
    $(this).parent('.item-level-1').addClass('active');
  });

  $( '.item-level-1>a' ).hover(
    function() {
      event.preventDefault();
      var curE = $(this);
      setTimeout(function(){
        var isHovered = curE.is(":hover");
        if(isHovered || curE.parent('.item-level-1').children('.level-2').is(":hover")){
          $('.item-level-1').removeClass('active');
          curE.parent('.item-level-1').addClass('active');
        }else{
          
        }
      }, 150);
      
    }, function() {
  //     var curE = $(this);
		// setTimeout(function(){
		// 	var isHovered = curE.is(":hover");
		// 	if(isHovered || curE.parent('.item-level-1').children('.level-2').is(":hover")){
              
		// 	}else{
		// 		$('.item-level-1').removeClass('active');
  //               $('.item-2').addClass('active');
		// 	}

		// }, 450);
      
      
    }
  );
  $( '.level-0' ).hover(
    function() {
      $('.item-level-1').removeClass('active');
    $(this).parent().find('.item-2').addClass('active');
      
    }, function() {
      
      
      
    }
  );

  $('.level-0').click(function (event) {
    $('.item-level-1').removeClass('active');
    $(this).parent().find('.item-2').addClass('active');
  });
   
    $('.footer__block--menu p, .footer__block--text p ').click(function(){
      if($(window).width() <767){
        if($(this).parent().hasClass('active')){
          $(this).parent().removeClass('active');
        }else{
          $(this).parent().addClass('active');
        }
      }
    });
});
$(window).on('load', function() {
  
    if($.trim($(".product-info variant-swatch-king").html())==''){
      $('.product-info variant-swatch-king').hide();
    }
  
  if(!$(".collection__facets input[name='filter.p.m.custom.show_on_collection']").is(":checked")){
    if($(".main-search-form").length){
      //$(".collection__facets input[name='filter.p.m.custom.show_on_collection']").trigger("click");
    }
    
  }
  if(!$(".collection__facets input[name='filter.p.m.custom.hide_on_webstore']").is(":checked")){
    //$(".collection__facets input[name='filter.p.m.custom.hide_on_webstore']").trigger("click");
  }
  $('body').addClass('loaded');
   $(".select-option-fake").change(function(e){
    var selected = $(this).val();
    $( "button.single-option-selector" ).each(function( index ) {
      if(selected == $(this).val()){
        $( this ).trigger( "click" );
      }
    });
  });

  $('.edit-location').click(function() {
  $('#ShippingLocation').val('');
  $('.shipping-estimator').removeClass('show-results');
  });
$('#read-shipping-terms').click(function() {
    if($(".shipping_accordion").attr("aria-expanded") == "false"){
      $(".shipping_accordion .accordion__toggle").trigger("click");
    }
    
    $('html, body').animate({
        scrollTop: $(".shipping_accordion").offset().top - 200
    }, 800);
  });

  $(document).on('click', '.js-open-promo-popup', async function (event) {

    const code = 'AFTERPAY10';

    // =========================
    // COPY TO CLIPBOARD
    // =========================
    try {
      await navigator.clipboard.writeText(code);
    } catch (error) {
      // Fallback
      const textarea = document.createElement('textarea');

      textarea.value = code;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';

      document.body.appendChild(textarea);

      textarea.select();
      document.execCommand('copy');

      textarea.remove();
    }

    // =========================
    // REMOVE TOAST CŨ
    // =========================
    const oldToast = document.querySelector('.promo-copy-toast');

    if (oldToast) {
      oldToast.remove();
    }

    // =========================
    // CREATE TOAST
    // =========================
    const toast = document.createElement('div');

    toast.className = 'promo-copy-toast';
    toast.textContent = 'AFTERPAY10 Copied!';

    document.body.appendChild(toast);

    // =========================
    // POSITION NEAR CURSOR
    // =========================

    const offsetX = 12;
    const offsetY = 12;

    let left = event.clientX + offsetX;
    let top = event.clientY + offsetY;

    // Không cho toast chạy ra ngoài bên phải
    const toastWidth = toast.offsetWidth;
    const toastHeight = toast.offsetHeight;

    if (left + toastWidth > window.innerWidth) {
      left = event.clientX - toastWidth - offsetX;
    }

    // Không cho toast chạy ra ngoài phía dưới
    if (top + toastHeight > window.innerHeight) {
      top = event.clientY - toastHeight - offsetY;
    }

    toast.style.left = `${left}px`;
    toast.style.top = `${top}px`;

    // Hiện toast
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });

    // =========================
    // HIDE AFTER 2 SECONDS
    // =========================
    setTimeout(function () {
      toast.classList.remove('is-visible');

      setTimeout(function () {
        toast.remove();
      }, 200);

    }, 1000);


  });

});